import PropTypes from "prop-types";
import { decimalAddZero } from "../../service/common";

import { classNames } from "primereact/utils";

export default function ModuleChartOverview({ data = [], headTemplate }) {
  return (
    <div className="bg-dark border-round-md px-1 py-2">
      {headTemplate}

      <div className="flex flex-wrap">
        {data.map((item) => (
          <div
            key={`${item.label}_${item.unit}`}
            className="text-white mx-3 my-2"
          >
            <div className="lg:text-lg mb-1">{item.label}</div>
            <div
              className={classNames(
                "text-3xl lg:text-4xl",
                item.valClassName
              )}
            >
              <span className="mr-2">
                {item.prefixVal}
                {typeof item.value === "number"
                  ? decimalAddZero({
                      rawVal: item.value,
                      decimalShowRaw: true,
                    })
                  : item.value ?? "--"}
              </span>
              <span>{item.unit}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

ModuleChartOverview.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      prefixVal: PropTypes.node,
      unit: PropTypes.string,
      valClassName: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  headTemplate: PropTypes.node,
};
